<template>
  <div>
     <public-title>用户列表</public-title>
     <div class="bg-white load-area">
        <!--搜索栏-->
        <div class="search-area">
          <left-text-select class="w-25 mr-4" leftText="绑定微信" :options="$GVAR.bindWechatType" v-model="searchCon.wechat" :width="90"/>
          <left-text-border class="w-25 mr-4" leftText="姓名" v-model="searchCon.truename" @enter="currentPage=1;getDataLists()" :width="50"/>
          <left-text-border class="w-25 mr-4" leftText="手机号" v-model="searchCon.mobile" @enter="currentPage=1;getDataLists()" :width="75"/>
          <div class="but">
              <el-button type="primary" size="small" @click="searchUser()" icon="el-icon-search">搜索</el-button>
              <el-button  size="small" @click="resetSearch()" icon="el-icon-refresh">重置</el-button>
          </div>
        </div>
        <!--表格-->
        <div v-if="list.length>0">
          <el-table
            class="customize-table"
            :data="list"
            ref="tableRef"
            :cell-style="{whiteSpace: 'pre-wrap'}"
            border
            max-height="850"
            style="width: 100%">
          <!--表单内容-->
          <el-table-column v-for="(item,index) in tableData" :key="index" :prop="item.prop" :label="item.name" :width="item.width" :min-width="item.minWidth" header-align="center" :sortable="item.sortable" :resizable="false">
            <!-- 自定义表头 -->
            <template slot="header" slot-scope="scope">
              <span>{{ scope.column.label }}</span>
              <!-- <p v-if="item.total">{{ AdminDataLists.info.total[item.total] /100 | formatMoney}}</p> -->
            </template>
            <template slot-scope="scope">
              <!--企业名称-->
              <div :class="{'text-center':item.center}" class="text-ellipsis"  v-if="item.pattern==='title'" @click="$emit('goStoreDetail',scope.row.id)">
                <el-popover placement="right" trigger="hover">
                  <div>
                      <span :class="[openid(scope.row.uid,scope.row.wechat_openid)?'text-success':'text-danger']">{{openid(scope.row.uid,scope.row.wechat_openid)?'已认证':'未认证'}} </span>
                  </div>
                  <i class=" text-link male iconfont icon-weixin1 ml-3" :class="[openid(scope.row.uid,scope.row.wechat_openid)?'text-success' : 'text-muted' ]" slot="reference" v-if="item.title!='无'"></i>
                </el-popover>
                {{scope.row[item.prop]| formatString(20)}}
              </div>
              <!--性别-->
              <div :class="{'text-center':item.center}"  v-else-if="item.pattern==='sex'">
                <span class="text-psis" :class="{ 'text-man':scope.row.sex==1,'text-woman':scope.row.sex==2 }">
                      {{ scope.row[item.prop]| formatVar('sex')}}
                </span>
              </div>
              <!--用户类型-->
              <div :class="{'text-center':item.center}"  v-else-if="item.pattern==='type'">{{ scope.row[item.prop]| formatVar('StoreType')}}</div>
              <!--级别-->
              <div :class="{'text-center':item.center}"  v-else-if="item.pattern==='level'">{{ scope.row[item.prop]| formatVar('userLevel')}}</div>
              <!--所属门店-->
              <div :class="{'text-center':item.center}"  v-else-if="item.pattern==='store_list'">
                <span v-if="scope.row[item.prop].length>0">
                  <i class=" text-link mr-1" :class="[scope.row[item.prop][0].verify==1?['el-icon-success','text-success']:['el-icon-error','text-danger']]" slot="reference"></i>
                  {{ scope.row[item.prop][0].title}}
                  <span class="ml-2 text-muted text-sm text-psis" v-if="scope.row[item.prop][0].position_name">{{ scope.row[item.prop][0].position_name}}</span>
                </span>
                <span v-else>无</span>
              </div>
                <!--门店个数-->
              <div :class="{'text-center':item.center}"  v-else-if="item.pattern==='store_num'">
                <el-popover placement="right" trigger="hover">
                  <div v-for="(v,ind) in scope.row[item.prop]" :key="ind" class="mb-3">
                    <i class=" text-link mr-1" :class="[v.verify==1?['el-icon-success','text-success']:['el-icon-error','text-danger']]" slot="reference"></i>
                    <span class="mr-2">{{v.title}}</span>
                    <span class="ml-2 text-muted text-sm text-psis text-sis" v-if="v.position_name">{{ v.position_name}}</span>
                  </div>
                  <span slot="reference" class="text-link" v-if=" scope.row[item.prop].length>0">{{ scope.row[item.prop].length}}</span>
                </el-popover>
                <span v-if=" scope.row[item.prop].length==0">0</span>
              </div>
              <!--时间-->
              <div :class="{'text-center':item.center}"  v-else-if="item.pattern==='time'">{{ scope.row[item.prop]| formatTimestamp(1)}}</div>
              <!--其他-->
              <div :class="{'text-center':item.center}" v-else>{{ scope.row[item.prop]}}</div>
            </template>
          </el-table-column>
            <!--操作按钮-->
            <el-table-column
              fixed="right"
              header-align="center"
              label="操作"
              width="150">
              <template slot-scope="scope">
                <div class="text-center">
                  <el-button v-if="Math.abs(scope.row.refund_fee)!=scope.row.total_fee" @click="checkDetail(scope.row)" type="text" size="small" >查看更多</el-button>
                  <el-button v-if="Math.abs(scope.row.refund_fee)!=scope.row.total_fee" @click="editUser(scope.row)" type="text" size="small" >编辑</el-button>
                </div>
              </template>
            </el-table-column>
        </el-table>
        <!--分页-->
        <div class="el-pagination">
          <el-pagination background layout="total,prev, pager, next" 
                  :page-size="20"
                  :total="total" :current-page="Number(formData.page)"
                  @current-change="$GFUN.pageChange"/>
        </div>
      </div>
      <div v-else>
          <div class="itemcard">
              <div class="no-search-result">
              <img src="/images/order/icon_22.png"/>
              <div class="no-search-text">
                  <p class="one">抱歉，没有搜索到相关结果。</p>
                  <p class="two">请更改筛选选项后重试</p>
                  <el-button type="primary" @click="resetSearch">清除选项</el-button>
              </div>
              </div>
          </div>
      </div>
     </div>
     <!--用户详情-->
      <el-dialog title="用户详情" :visible.sync="showDetail" center :show-close="false">
        <div class="d-flex flex-wrap">
          <div class="d-center-start w-50 mb-3" v-for="item in showDetailArr" :key="item.name">
            <left-text :leftText="item.name"/><span v-html="currentItem[item.value]"></span>
          </div>
          <div class="d-center-start w-50 mb-3">
            <left-text leftText="实名认证"/><span v-html="currentItem.is_real==1?'已认证':'未认证'"></span>
            <el-button  type="primary" size="mini" class="ml-2" v-if="currentItem.is_real==1" @click="realDetails(currentItem)">查看详情</el-button>
          </div>
          <div class="d-center-start w-50 mb-3">
            <left-text leftText="账号密码"/>
            <span v-show="showPassword" class="mr-2">{{currentItem.password}}</span>
            <i class="iconfont text-link" @click="showPassword = !showPassword"
               :class="[showPassword ? 'icon-yanjing-zheng' : 'icon-yanjing-bi']"></i>
          </div>
        </div>
        <el-button slot="footer" type="primary" @click="showDetail = false">确 定</el-button>
      </el-dialog>
      <el-dialog title="用户实名信息" :visible.sync="showRealVerifyInfo" center :show-close="false">
        <h4 class="real-name">
          <p>真实姓名：</p>
          <span>{{realVerifyInfo.truename}}</span>
        </h4>
        <div class="real-img">
          <div>
            <upload-image  :existImgs="realVerifyInfo.card_a"  :maxLength="1" class="upload-image" :identityMode="true" />
            <p>身份证正面</p>
          </div>
          <div> 
            <upload-image  :existImgs="realVerifyInfo.card_b"  :maxLength="1" class="upload-image" :identityMode="true" />
            <p>身份证反面</p>
          </div>
        </div>
        <el-button slot="footer" type="primary" @click="showRealVerifyInfo = false">确 定</el-button>
      </el-dialog>
  </div>
</template>

<script>
  import { mapGetters,mapActions,mapState } from 'vuex'
export default {
  name: '',
  components: {}, 
  props: {},
  data() {
    return {
      formData:{
        page:'1',
      },
      //搜索条件
      searchCon:{
        wechat:'',
        truename:'',
        mobile:'',
      },
      list:[],
      total:0,
      tableData:[ 
          {name:'用户姓名',prop:'truename',width:200,pattern:'title'},
          {name:'手机号',prop:'mobile',width:150,center:true,},
          {name:'性别',prop:'sex', minWidth:80  ,center:true,pattern:'sex'},
          {name:'用户类型',prop:'type', minWidth:100,center:true,pattern:'type'},
          {name:'级别',prop:'level', minWidth:80,center:true,pattern:'level'},
          {name:'所属门店',prop:'store_list', minWidth:250,pattern:'store_list'},
          {name:'门店个数',prop:'store_list', minWidth:80,center:true,pattern:'store_num'},
          {name:'登录次数',prop:'num', minWidth:100,center:true,pattern:'province'},
          {name:'上次登录时间',prop:'login_time', minWidth:100,center:true,pattern:'time'},
      ],
      showDetailArr:[
        {name:'用户姓名',value:'truename'},{name:'注册来源',value:'trace'},{name:'用户类型',value:'type'},
        {name:'上次登录时间',value:'login_time'},{name:'手机号',value:'mobile'},
        {name:'绑定微信',value:'wechat_openid'},{name:'注册时间',value:'reg_time'},{name:'登录次数',value:'num'}
      ],
      showDetail:false,
      currentItem:{},
      showPassword:false,
      showRealVerifyInfo:false,     //用户实名信息弹窗
      realVerifyInfo:{},              //当前用户实名信息详情
    };
  },
  computed: {
    ...mapState(['AdminDataLists','AdminDataDetail']),
    ...mapGetters(['storeInfo']),
    type() {  return this.$route.query.type || '3' },
    level() { return this.$route.query.level || '3' },
    page() { return this.$route.query.page || 0 },

  },
  watch: {
    $route(to, from) {
      if(!to.query.page){
        this.searchCon = {
          wechat: '',
          truename: '',
          mobile: '',
        }
        this.formData = { ...this.formData, ...this.searchCon }
        this.getDataLists();
      }
    },
    page:{
      handler(newVal,oldVal){
        if(newVal>0){
          this.formData.page = newVal;
          this.getDataLists();
        }

      },
    },
  },
  created() {},
  mounted() {
    this.getDataLists();
  },
  methods: {
    ...mapActions(['POST_Admin_UserLists','getItemDetail','POST_RealVerifyInfo']),  
      //获取用户列表
      getDataLists() {
        this.POST_Admin_UserLists({
          data:{
            ...this.formData,
            type:this.type,
            level:this.level,
            num:20,
          },
          successFun:(res)=>{
            this.list = res.list;
            this.total = res.count;
            // 获取表格内部滚动容器
            let tableWrap = this.$refs.tableRef
            if(tableWrap){
              tableWrap=tableWrap.bodyWrapper
              tableWrap.scrollTo({
                top: 0,
                behavior: 'smooth'
              })
            }
          }
        });
      },
      //判断是否绑定微信
      openid(uid,wechat_openid){
        return wechat_openid==''||uid==wechat_openid?false:true;
      },
      //编辑用户
      editUser(item) {
        if (!this.$GFUN.powerIsInArray([81])) { this._alert('您没有相关权限！',null,'error'); return; }
        let {uid,truename,mobile,status,wechat_openid,type,sex} = item;
        this.$router.push({name:'editUser',query:{uid,truename,mobile,status,wechat_openid,type,sex}})
      },
      //搜索用户
      searchUser() {
        this.formData = { ...this.formData, ...this.searchCon }
        this.handleSearchCommon()
      },

      //重置搜索条件
      resetSearch() {
        this.searchCon = {
          wechat: '',
          truename: '',
          mobile: '',
        }
        this.formData = { ...this.formData, ...this.searchCon }
        this.handleSearchCommon()
      },

      /**
       * 搜索/重置公共处理：page重置 + 路由/列表请求
       */
      handleSearchCommon() {
        if (this.formData.page > 1) {
          this.formData.page = 1
          this.$router.push({
            name: 'UserManage',
            query: {
              ...this.$route.query,
              page: 1
            }
          })
        } else {
          this.getDataLists()
        }
      },
      //用户实名认证信息
      realDetails(item){
        this.POST_RealVerifyInfo({
          data:{
            uid:item.uid,
          },
          successFun:(res)=>{
            this.showRealVerifyInfo = true;
            this.realVerifyInfo = res.info;
          }
        })
      },
      async checkDetail(item) {
        if (!this.$GFUN.powerIsInArray([80])) { this._alert('您没有相关权限！',null,'error'); return; }
        await this.getItemDetail({
          type:'userDetail',
          data:{
            uid:item.uid,
            uid:item.uid,
            // store_type:item.type
          }
        })
        this.currentItem = {
          ...this.AdminDataDetail,
          wechat_openid:` ${item.wechat_openid!=item.uid ? '已绑定' : '未绑定'}`,
          type:this.$options.filters['formatVar'](item.type,'StoreType'),
          trace:this.$options.filters['formatVar'](this.AdminDataDetail.trace,'traces'),
          login_time:item.login_time > 0 ? this.$options.filters['formatTimestamp'](item.login_time,1) : '从未登录',
          reg_time:this.$options.filters['formatTimestamp'](this.AdminDataDetail.reg_time,1)
        };
        this.showDetail = true;
      },
  }
};
</script>

<style lang="scss" scoped>
.load-area{
  background-color:inherit !important;
  padding:0 !important;;
}
.search-area{                                                                                       
  background-color: #fff;
  text-align:left;
  padding:20px 30px;
  border-radius: 6px;
  display: flex;
}
.but{
  margin-left: auto;
}
.customize-table{
  margin-top: 20px;
}
.text-link{
  cursor: pointer;
}
.icon-weixin1{
  margin-right: 4px;
  margin-left: 4px;
  font-size: 14px;
}
.el-pagination{
  background-color: #fff;
  margin-top:14px;
  padding-bottom:10px;
}
.text-muted{
  color: #999;
}
  .no-search-result{
    width: 100%;
    background-color: #fff;
    box-shadow: 0px 0px 7px #eee;
    border-radius: 16px;
    display: flex;
    justify-content: center;
    padding: 52px 0;
    margin-top: 20px;
    img{
      width: 120px;
    }  
  }
  .no-search-text{
    margin-left: 14px;
    text-align: left;
    .one{
      font-weight: bold;
      font-size: 16px;
    }
    .two{
      color: #666;
      margin: 6px 0;
    }
  }
  .text-psis{
    background-color: #f5f6f9;
    color: #6e7789;
    padding: 6px 8px;
    border-radius: 4px;
    font-size: 12px;
  }
  .text-man{
    background-color: var(--smtc-color-primary);
    color: var(--smtc-color-white);
  }
  .text-woman{
    background-color: var(--smtc-color-text-paleRed);
    color: var(--smtc-color-white);
  }
  .text-sm{
    background-color: var(--smtc-color-text-back);
    color: var(--smtc-color-white) !important;
  }
  .text-sis{
    font-size: 10px;
    padding: 4px 6px;
  }
  .real-img{
    display: flex;
    justify-content: space-between;
  }
  .real-img div{
    width: 48%;
    p{
       text-align: center;
       margin-top: 10px;
    }
  }
  .real-name{
    display: flex;
    margin-bottom: 20px;
  }
</style>
<style>
  .customize-table .has-gutter th,.customize-table th.el-table__cell{
    background: #f7f7f9;
    color: #333;
  }
</style>
